<template>
<w-setting-sliding-popup ref="slidingPopup" :title="titleName" @close="close" width="500px">
  <el-form slot="content" :model="modelInfo" label-position="top" :ref="formName">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="벤더" prop="objCompanyName">
          <el-select :disabled="!isAdd" v-model="selectObjCompanyId" style="width:100%" filterable auto-complete default-first-option @change="selectVenderChange">
            <el-option v-for="item in venderInfoList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="벤더사 OID" prop="objCompanyOid">
          <el-input :disabled="true" v-model="modelInfo.objCompanyOid"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item v-if="!isCustomProductId" label="모델 명" prop="objProductId" :rules="{ trigger: 'change', required: true, validator: this.validateModel }">
          <div style="display:flex">
            <div class="mr-r4" style="width:calc(100% - 34px);">
              <el-select :disabled="!isAdd"  v-model="modelInfo.objProductId" filterable style="width:100%" :allow-create="false" default-first-option>
                <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
              </el-select>
            </div>
            <el-button :disabled="!isAdd" size="mini" type="content" icon="fas fa-pen" @click="isCustomProductId = !isCustomProductId" />
          </div>
        </el-form-item>
        <el-form-item v-else label="모델 명" prop="customProductId" :rules="{ trigger: 'blur', required: true, message: '필수 정보입니다.', validator: this.validateModel }">
          <div style="display:flex">
            <div class="mr-r4" style="width:calc(100% - 34px);">
              <el-input v-model="modelInfo.customProductId" style="width:100%" />
            </div>
            <el-button size="mini" type="content" icon="fas fa-pen" @click="isCustomProductId = !isCustomProductId" />
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="장비 종류" prop="objtypeId" :rules="{ trigger: 'change', required: true }">
          <el-select :disabled="!isAdd" v-model="modelInfo.objtypeId" filterable style="width:100%" :allow-create="false" default-first-option>
            <el-option v-for="item in objtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="모델 OID" prop="objOid" :rules="{ required: true, trigger: 'blur', validator: this.getValidateOid }">
          <el-input v-model="modelInfo.objOid"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveModelOid">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import { isEmpty, clone, isNil, find } from 'lodash';
import msgUtil from '@/utils/message';
import ProductAPI from '@/api/model/obj-product';
import ObjtypeAPI from '@/api/model/objtype';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import { validateOid } from '@/utils/string';

export default {
  name: 'WModelOidPopup',
  props: {
    editRow: Object,
    modelPopupType: String,
    isAdd: Boolean,
  },
  data() {
    return {
      selectObjCompanyId: null,
      venderInfoList: [],
      productInfoList: [],
      objtypeList: [],
      formName: 'modelInfoForm',
      titleName: '',
      isCustomProductId: false,
      modelInfo: {
        objCompanyId: null,
        objCompanyOid: null,
        objCompanyName: null,
        objProductId: null,
        customProductId: null,
        objOid: null,
        objtypeId: null,
      },
    };
  },
  watch: {
    editRow: {
      handler(row) {
        if (this.modelPopupType === 'ADD') {
          this.titleName = '모델 OID 추가';
        } else if (this.modelPopupType === 'EDIT') {
          this.modelInfo = clone(row);
          this.titleName = '모델 OID 수정';
          this.selectObjCompanyId = this.editRow.objCompanyId;
        }
      },
      immediate: true,
    },
    selectObjCompanyId: {
      handler() {
        if (!isNil(this.selectObjCompanyId) || this.selectObjCompanyId !== '') {
          this.loadProductList();
        }
      },
      immediate: true,
    },
    isCustomProductId() {
      this.$refs.modelInfoForm.clearValidate('objProductId');
      this.$refs.modelInfoForm.clearValidate('customProductId');
    },
  },
  methods: {
    close() {
      this.selectObjCompanyId = null;
      this.isCustomProductId = false;
      this.$refs[this.formName].resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.loadVendorList();
      this.loadObjtypeList();
    },
    /**
     * [selectVenderChange 벤더명 combobox가 변하는 경우 선택된 값이 모델에 저장될 수 있도록 한다.]
     * @author yelim
     */
    selectVenderChange(value) {
      this.selectObjCompanyId = value;
      const findData = (find(this.venderInfoList, (item) => (item.objCompanyId === value)));
      this.modelInfo.objCompanyId = findData.objCompanyId;
      this.modelInfo.objCompanyOid = findData.objCompanyOid;
    },
    /**
     * [loadVendorList 벤더 리스트를 로드한다. 벤더 리스트는 벤더 OID 목록에 출력된 항목과 같다.]
     * @author yelim
     */
    loadVendorList() {
      NetdeviceSettingAPI.getVendorOidList({}).then((result) => {
        if (result.data.success) {
          this.venderInfoList = result.data.data;
          if (!isEmpty(result.data.data)) {
            // 리스트의 첫 번째 벤더가 선택 될 수 있도록 한다.
            const firstVender = result.data.data[0];
            if (this.modelPopupType === 'ADD') {
              this.selectObjCompanyId = firstVender.objCompanyId;
            }
            this.modelInfo.objCompanyId = firstVender.objCompanyId;
            this.modelInfo.objCompanyOid = firstVender.objCompanyOid;
          } else {
            this.modelInfo.objCompanyId = '';
            this.modelInfo.objCompanyOid = '';
          }
        }
      });
    },
    /**
     * [loadProductList 모델 리스트를 로드한다. 벤더에 속하는 모델의 리스트를 로드한다.]
     * @author yelim
     */
    loadProductList() {
      if (!isNil(this.selectObjCompanyId)) {
        ProductAPI.getObjProductListByCompany({ objCompanyId: this.selectObjCompanyId }).then((result) => {
          if (result.data.success) {
            this.productInfoList = result.data.data;
            if (!isEmpty(result.data.data)) {
              const firstProduct = result.data.data[0];
              if (this.modelPopupType === 'ADD') {
                this.modelInfo.objProductId = firstProduct.objProductId;
              }
            } else {
              this.modelInfo.objProductId = null;
            }
          }
        });
      }
    },
    loadObjtypeList() {
      ObjtypeAPI.getObjtypeList('NMS').then((response) => {
        const result = response.data;
        if (result.success) {
          this.objtypeList = result.data;
          if (this.modelPopupType === 'ADD') {
            if (result.data.length > 0) {
              this.modelInfo.objtypeId = result.data[0].objtypeId;
            }
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 종류 목록', result.success));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 종류 목록', false));
      });
    },
    getValidateOid(rule, value, callback) {
      if (isNil(value) || value.length === 0) {
        callback(new Error('필수 정보입니다.'));
      } else {
        /* eslint-disable no-lonely-if */
        if (validateOid(value)) {
          callback();
        } else {
          callback(new Error('올바른 OID 형식을 입력해주세요'));
        }
        /* eslint-enable no-lonely-if */
      }
    },
    /**
     * [saveModelOid Model Oid 항목을 추가 또는 수정한다.]
     * @author yelim
     */
    saveModelOid() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.modelPopupType === 'ADD') {
            const saveParmas = {
              objCompanyId: this.modelInfo.objCompanyId,
              objOid: this.modelInfo.objOid,
              objProductId: this.isCustomProductId ? this.modelInfo.customProductId : this.modelInfo.objProductId,
              objtypeId: this.modelInfo.objtypeId,
            };
            NetdeviceSettingAPI.insertModelInfoList(saveParmas).then((response) => {
              if (response.data.success) {
                this.closePopup();
                this.$emit('reload-data');
              } else if (!response.data.success && response.data.message === 'Duplicate') {
                this.$message(msgUtil.getCustomMsgData('이미 OID가 설정된 모델입니다.'));
                return;
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, 'OID', response.data.success));
            });
          } else if (this.modelPopupType === 'EDIT') {
            const saveParmas = {
              objCompanyId: this.selectObjCompanyId,
              lastObjOid: this.editRow.objOid,
              objOid: this.modelInfo.objOid,
              objProductId: this.isCustomProductId ? this.modelInfo.customProductId : this.modelInfo.objProductId,
            };
            NetdeviceSettingAPI.updateModelInfoList(saveParmas).then((response) => {
              if (response.data.success) {
                this.closePopup();
                this.$emit('reload-data');
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, 'OID', response.data.success));
            });
          }
        }
      });
    },
    validateModel(rule, value, callback) {
      if (isNil(value) || value.length === 0) {
        callback(new Error('필수 정보입니다.'));
      } else {
        /* eslint-disable no-lonely-if */
        if (this.isAdd) {
          const params = {
            showFlag: 1,
            objCompanyId: this.modelInfo.objCompanyId,
            objProductId: this.isCustomProductId ? this.modelInfo.customProductId : this.modelInfo.objProductId,
          };
          NetdeviceSettingAPI.getModelOidList(params).then((result) => {
            if (result.data.success) {
              const resultCnt = result.data.data.length;
              if (resultCnt > 0) {
                callback(new Error('이미 OID가 설정된 모델입니다.'));
              } else {
                callback();
              }
            }
          });
        } else {
          callback();
        }
        /* eslint-enable no-lonely-if */
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/popup/ModelOidPopup.vue